import { getAppSettings } from '../../Util/globalAppSettings';
import { SourceBase } from './SourceBase';
import type { TrafikverketSourceOptions } from './Sources.types';

interface TrafikverketResponse {
    RESPONSE: {
        RESULT: [
            {
                ERROR?: {
                    MESSAGE: string;
                };
                [key: string]: unknown;
            },
        ];
    };
}

export abstract class TrafikverketSource extends SourceBase<TrafikverketSourceOptions> {
    constructor(options: TrafikverketSourceOptions) {
        super(options);

        this.options.apiKey = getAppSettings().trafikverketAPIKey;
        this.options.url = getAppSettings().trafikverketAPIUrl;
    }

    hasDetailsLoader(): boolean {
        return !!this.options.detailQuery;
    }

    getAjaxPromise(query?: string): Promise<unknown> {
        return this._fetchData(query || this.options.query)
            .then((response) => {
                if (response.ok) {
                    return response.json();
                }
            })
            .then(this.extractResponse.bind(this));
    }

    _fetchData(query: string): Promise<Response> {
        const request = `
            <REQUEST>
                <LOGIN authenticationkey="${this.options.apiKey}" />
                <QUERY objecttype="${this.options.objectType}" schemaversion="${this.options.schemaVersion}"${this.options.namespace ? ` namespace="${this.options.namespace}"` : ''}>
                    ${query}
                </QUERY>
            </REQUEST>
        `;

        return fetch(this.options.url, {
            method: 'POST',
            headers: {
                'Content-Type': 'text/xml',
            },
            body: request,
        });
    }

    extractResponse(response: TrafikverketResponse): unknown {
        const responseData = response.RESPONSE.RESULT[0];
        if (responseData.ERROR) {
            throw new Error('Trafikverket request failed: ' + responseData.ERROR.MESSAGE);
        } else {
            return response.RESPONSE.RESULT[0][this.options.objectType];
        }
    }
}
